import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { readableStreamLikeToAsyncGenerator } from 'rxjs/internal/util/isReadableStreamLike';
import { EnquiryService } from '../../../shared/services/enquiry.service';
import { AlertService } from '../../../shared/services/alert.service';
import { GlobalService } from '../../../shared/services/global.service';
import {Meta, Title} from "@angular/platform-browser";


@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss'],
  providers: [EnquiryService, GlobalService]
})
export class AboutUsComponent implements OnInit {
  addEnquiryForm: FormGroup = new FormGroup({});
  submitted: any = false;
  faqs = [
    {
      question: 'What is Payment Gateway?',
      answer: 'A payment gateway is a technology platform that acts as an intermediary in electronic financial transactions. It enables in-person and online businesses to accept, process, and manage various payment methods—such as credit cards, debit cards, and digital wallets—in a secure and efficient manner.',
      expanded: false
    },
    {
      question: 'What is Payment Gateway?',
      answer: 'A payment gateway is a technology platform that acts as an intermediary in electronic financial transactions. It enables in-person and online businesses to accept, process, and manage various payment methods—such as credit cards, debit cards, and digital wallets—in a secure and efficient manner.',
      expanded: false
    },
    {
      question: 'What is Payment Gateway?',
      answer: 'A payment gateway is a technology platform that acts as an intermediary in electronic financial transactions. It enables in-person and online businesses to accept, process, and manage various payment methods—such as credit cards, debit cards, and digital wallets—in a secure and efficient manner.',
      expanded: false
    },
    {
      question: 'What is Payment Gateway?',
      answer: 'A payment gateway is a technology platform that acts as an intermediary in electronic financial transactions. It enables in-person and online businesses to accept, process, and manage various payment methods—such as credit cards, debit cards, and digital wallets—in a secure and efficient manner.',
      expanded: false
    },
    {
      question: 'What is Payment Gateway?',
      answer: 'A payment gateway is a technology platform that acts as an intermediary in electronic financial transactions. It enables in-person and online businesses to accept, process, and manage various payment methods—such as credit cards, debit cards, and digital wallets—in a secure and efficient manner.',
      expanded: false
    }];

  toggleExpand(faq: any) {
    faq.expanded = !faq.expanded;
  }

  constructor(private router: Router,
              private formBuilder: FormBuilder,
              private enquiryService: EnquiryService,
              private alertService: AlertService,
              private title : Title,
              private meta : Meta,) {
  }

  ngOnInit(): void {
    this.updateMetaTags
    this.refresh();
  }

  refresh() {
    this.addEnquiryForm = this.formBuilder.group({
      name: ['', Validators.required],
      email: ['', Validators.compose([Validators.required, Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
      contact: ['', Validators.required],
      subject: ['', Validators.required]
    });
  }

  goTo(url) {
    this.router.navigateByUrl(url);
  }

  submit() {
    this.submitted = true;
    if (!this.addEnquiryForm.valid) {
      return;
    }
    if (this.submitted) {
      const params: {} = {
        'name': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().name) ? this.addEnquiryForm.getRawValue().name : '',
        'email': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().email) ? this.addEnquiryForm.getRawValue().email : '',
        'contact': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().contact) ? this.addEnquiryForm.getRawValue().contact : '',
        'subject': (this.addEnquiryForm && this.addEnquiryForm.getRawValue() && this.addEnquiryForm.getRawValue().subject) ? this.addEnquiryForm.getRawValue().subject : ''
      };
      this.enquiryService.add(params).subscribe(data => {
        this.submitted = false;
        this.addEnquiryForm.reset();
      }, error => {
        this.submitted = false;
        this.alertService.showErrors(error['error']['error']);
      });
    }
  }


  updateMetaTags() {
    this.title.setTitle('About Us - Enroll Admission Management Software');
    this.meta.updateTag({name: 'description', content: `Enroll, an Admission Management Software, designed to simplify student enrollment operations and streamline admissions processes for universities, schools, and colleges.`});
  }
}
